// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-d7d81972] .v-card {\n  border-radius: 4px;\n}", ""]);
// Exports
module.exports = exports;
